import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TaskFilterService {
  private showAllSubject = new BehaviorSubject<boolean>(false);
  public showAll$ = this.showAllSubject.asObservable();

  private lastWeekSubject = new BehaviorSubject<boolean>(false);
  public lastWeek$ = this.lastWeekSubject.asObservable();

  constructor() {}

  setShowAll(showAll: boolean): void {
    this.showAllSubject.next(showAll);
  }

  getShowAll(): boolean {
    return this.showAllSubject.value;
  }

  setLastWeek(lastWeek: boolean): void {
    this.lastWeekSubject.next(lastWeek);
  }

  getLastWeek(): boolean {
    return this.lastWeekSubject.value;
  }
}
